export default __webpack_public_path__ + "static/media/faralya8.3277365d.jpg";